import { Link } from "react-router-dom";
import { Badge } from "./ui/badge";
import { photoUrl } from "../lib/api";
import { MapPin, Star, BadgeCheck, ShowerHead } from "lucide-react";

export default function ProviderCard({ provider, categories }) {
  const cat = categories?.find((c) => c.id === provider.category);
  const photo = provider.photos?.[0];
  return (
    <Link to={`/prestador/${provider.provider_id}`} data-testid={`provider-card-${provider.provider_id}`}>
      <div className="bg-white rounded-2xl overflow-hidden card-hover border border-brand-coral/5 h-full flex flex-col">
        <div className="relative h-44 bg-brand-mintLight">
          {photo ? (
            <img src={photoUrl(photo)} alt={provider.business_name} className="w-full h-full object-cover" />
          ) : (
            <div className="w-full h-full flex items-center justify-center text-brand-mint"><ShowerHead className="w-10 h-10" /></div>
          )}
          {provider.featured && (
            <span className="absolute top-3 left-3 bg-brand-mustard text-brand-graphite text-xs font-semibold px-2.5 py-1 rounded-full">Destaque</span>
          )}
          {provider.category === "banho_automatico" && (
            <span className="absolute top-3 right-3 bg-brand-coral text-white text-xs font-semibold px-2.5 py-1 rounded-full">24h</span>
          )}
        </div>
        <div className="p-5 flex flex-col flex-1">
          <div className="flex items-center gap-1.5 mb-1">
            <h3 className="font-heading font-semibold text-lg text-brand-graphite leading-tight">{provider.business_name}</h3>
            {provider.verified && <BadgeCheck className="w-4 h-4 text-brand-mint shrink-0" data-testid="verified-badge" />}
          </div>
          <p className="text-xs font-medium text-brand-coral uppercase tracking-wide mb-2">{cat?.name || provider.category}</p>
          <p className="text-sm text-muted-foreground line-clamp-2 flex-1">{provider.description}</p>
          <div className="flex items-center justify-between mt-4">
            <span className="flex items-center text-xs text-muted-foreground">
              <MapPin className="w-3.5 h-3.5 mr-1 text-brand-mint" />
              {provider.neighborhoods?.[0] || provider.city}
            </span>
            <span className="flex items-center gap-1 text-sm font-semibold text-brand-graphite" data-testid="provider-rating">
              <Star className="w-4 h-4 fill-brand-mustard text-brand-mustard" />
              {provider.rating_avg > 0 ? provider.rating_avg : "Novo"}
              {provider.rating_count > 0 && <span className="text-xs font-normal text-muted-foreground">({provider.rating_count})</span>}
            </span>
          </div>
        </div>
      </div>
    </Link>
  );
}
